import React from "react";
import { DrawerProps, Drawer, Descriptions, TableProps, Table, Space } from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppSelector } from "../../../../utils/hooks/hooks";
import { generateColumn, renderNA } from "../../../../utils/commonFunctions";
import { RootState } from "../../../../store/app";
import AllExamList from "./Listing/AllExamList";

/**
 * Renders a drawer component for viewing details of an interest Discovery result of user.
 *
 * @param {ViewDrawerProps} props - The props object containing the following properties:
 *   - titleName: The name of the title for the drawer.
 *   - open: A boolean indicating whether the drawer is open or not.
 *   - close: A function to close the drawer.
 *   - rest: Any additional props to be spread onto the Drawer component.
 * @return {JSX.Element} The rendered ViewInterestAssessmentDrawer component.
 */
const ViewAllExamDetails: React.FC<any> = ({
  moduleInfo,
  handleViewInterestAssessmentClick,
  handleViewSkillAssessmentClick,
  handleViewAssessmentResultClick,
  titleName,
  open,
  close,
  ...rest
}) => {
  const details = useAppSelector(
    (state: RootState) => state.user.details
  );
  // const examDetails = useAppSelector(
  //   (state: RootState) => state.user.allExamDetails
  // );


  const drawerClose = () => {
    console.log('close');
    close();

  };




  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
       
      width={"90%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Descriptions column={2} bordered layout="horizontal">
          <Descriptions.Item label="First Name">
            {renderNA(details?.name)}
          </Descriptions.Item>
          <Descriptions.Item label="Last Name">
            {renderNA(details?.last_name)}
          </Descriptions.Item>
          <Descriptions.Item label="Mobile Number">
            {renderNA(details?.mobile_no)}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {renderNA(details?.email)}
          </Descriptions.Item>
        </Descriptions>
      </Space>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div className="all-exam-table-section">

        <AllExamList
          moduleInfo={moduleInfo}
          handleViewInterestAssessmentClick={handleViewInterestAssessmentClick}
          handleViewSkillAssessmentClick={handleViewSkillAssessmentClick}
          handleViewAssessmentResultClick={handleViewAssessmentResultClick}
          user_id={details?.id}
        />
        </div>
      </Space>

    </Drawer>
  );
};

export default ViewAllExamDetails;
